




















import {Drag} from "vue-drag-drop";
import {Vue, Component, Prop} from "vue-property-decorator";
import DynamicComponents from "./DynamicComponents.vue";
import {SComponentsGroup} from "@/components/dto/SComponentsGroup";
import ComponentList from "@/components/ComponentList.vue";

@Component({
    components: {ComponentList, DynamicComponents,Drag}
})
export default class CollapseComponentList extends Vue {
    @Prop() groups!: SComponentsGroup[];
    @Prop() data!: any;

    handle_function_call(e: any, param: any) {
        this.$emit('callfunction', e, param);
    }
}
